import { useEffect, useRef, useState } from "react";
import { useDraggable } from "react-use-draggable-scroll";
import styles from "./SearchUsersModal.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Ok } from "react-ikonate";
import nextId from "react-id-generator";
/**
 *
 * Modal used for searching users when adding an admin on the admins tab of the groups page.
 */

export function SearchUsersModal({ isOpen, onClose, onClick, iboInfos }) {
  const ref = useRef(); // We will use React useRef hook to reference the wrapping div:
  const { events } = useDraggable(ref, {
    applyRubberBandEffect: true,
  }); // Now we pass the reference to the useDraggable hook:
  const draggerId = "draggerId" + nextId();
  //console.log(draggerId);

  iboInfos.sort((a, b) => (a.adminName > b.adminName ? 1 : -1));

  const [iboInfosState, setIboInfosState] = useState(iboInfos);
  const [checkedUsersState, setCheckedUsersState] = useState([]);
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {}, [checkedUsersState, searchInput]);

  function checkUser(iboNum) {
    if (checkedUsersState.includes(iboNum)) {
      const index = checkedUsersState.indexOf(iboNum);
      setCheckedUsersState((checkedUsersState) =>
        checkedUsersState.filter((iboNum, i) => i !== index)
      );
    } else {
      setCheckedUsersState((checkedUsersState) => [
        ...checkedUsersState,
        iboNum,
      ]);
    }
  }

  function search() {
    var filteredResults = []; // {iboInfo, hammingDistance}
    for (var i = 0; i < iboInfos.length; i++) {
      var d = hammingDistance(
        searchInput.toLowerCase(),
        iboInfos[i].adminName.toLowerCase()
      );
      filteredResults.push({ iboInfo: iboInfos[i], hammingDistance: d });
    }

    filteredResults.sort((a, b) =>
      a.hammingDistance > b.hammingDistance ? 1 : -1
    );

    var filteredIboInfos = [];
    for (var i = 0; i < filteredResults.length; i++) {
      filteredIboInfos.push(filteredResults[i].iboInfo);
    }

    setIboInfosState(filteredIboInfos);

    document.getElementById(draggerId).scrollTo(0, 0);
  }

  function hammingDistance(s, t) {
    var dist_counter = 0;
    for (var n = 0; n < s.length && n < t.length; n++) {
      if (s[n] != t[n]) {
        dist_counter++;
      }
    }
    return dist_counter;
  }

  function handleKeyDown(value) {
    if (value.key == "Enter") {
      search();
    }
  }

  // using styles to hide it because of some weridness with the dragger having elements that don't exist and whatnot
  return (
    <div
      className={classNames(styles.containerContainer, !isOpen && styles.hide)}
    >
      <div className={styles.modalBackground} onClick={onClose} />

      <div className={styles.container}>
        <div className={styles.bold}>SEARCH USERS</div>
        <div className={styles.hr} />

        <div className={styles.inputContainer}>
          <div className={styles.search} onClick={() => search()}>
            <div className={styles.circle} />
            <div className={styles.handle} />
          </div>

          <input
            type="text"
            placeholder="Search"
            value={searchInput}
            className={styles.inputField}
            onChange={(e) => setSearchInput(e.target.value)}
            onKeyDown={(e) => handleKeyDown(e)}
          />

          <button className={styles.button} onClick={() => search()}>
            SEARCH
          </button>
        </div>
        <div className={styles.listContainer}>
          <div className={styles.header}>
            <div>IBO Name</div>
            <div>IBO #</div>
          </div>
          <div className={styles.dragger} {...events} ref={ref} id={draggerId}>
            {iboInfosState.map((item, index) => (
              <div
                className={classNames(
                  styles.whiteBG,
                  index % 2 == 1 && styles.slightlyDarkerBackground
                )}
                key={index}
              >
                <div className={styles.itemContainer}>
                  <div className={styles.item}>
                    <button
                      className={classNames(
                        styles.checkboxContainer,
                        checkedUsersState.includes(item.iboNum) &&
                          styles.checked
                      )}
                      onClick={() => checkUser(item.iboNum)}
                    >
                      <div
                        className={classNames(
                          styles.icon,
                          !checkedUsersState.includes(item.iboNum) &&
                            styles.hidden
                        )}
                      >
                        <Ok />
                      </div>
                    </button>
                    {item.adminName}
                  </div>
                  <div className={styles.item}>{item.iboNum}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.buttonContainer}>
          <button
            className={classNames(styles.button, styles.cancelBtn)}
            onClick={onClose}
          >
            CANCEL
          </button>
          <button
            className={styles.button}
            onClick={() => onClick(checkedUsersState)}
          >
            ADD ADMIN
          </button>
        </div>
      </div>
    </div>
  );
}

SearchUsersModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
  iboInfos: PropTypes.arrayOf(PropTypes.object),
};
